//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export enum BulkActionNames {
  ADD_LABELS = 'ADD_LABELS',
  ADD_TO_COLLECTION = 'ADD_TO_COLLECTION',
  ADD_TO_FANREEL = 'ADD_TO_FANREEL',
  ADD_TO_GALLERY = 'ADD_TO_GALLERY',
  ADD_TO_LIBRARY = 'ADD_TO_LIBRARY',
  ADD_TO_STREAM = 'ADD_TO_STREAM',
  DELETE_CREATOR_CAMPAIGN_CONTENT = 'DELETE_CREATOR_CAMPAIGN_CONTENT',
  DOWNLOAD = 'DOWNLOAD',
  PUBLISH_TO_GOOGLE_ASSET_FEED = 'PUBLISH_TO_GOOGLE_ASSET_FEED',
  REMOVE_FROM_COLLECTION = 'REMOVE_FROM_COLLECTION',
  REMOVE_FROM_CONNECT = 'REMOVE_FROM_CONNECT',
  REMOVE_FROM_GALLERY = 'REMOVE_FROM_GALLERY',
  REMOVE_FROM_GOOGLE_ASSET_FEED = 'REMOVE_FROM_GOOGLE_ASSET_FEED',
  REMOVE_FROM_LIBRARY = 'REMOVE_FROM_LIBRARY',
  REMOVE_LABELS = 'REMOVE_LABELS',
  REPORT_AI_CONTENT = 'REPORT_AI_CONTENT',
  REQUEST_REVIEW_NOW = 'REQUEST_REVIEW_NOW',
}
